import { AppDispatch } from '../../redux/store';
import CardWrapper from '../../components/wrapper/card';
import CustomerManagementComponent from '../../components/customer_management';
import CustomInput from '../../components/reusable/input';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import InviteCustomerModal from '../../components/customer_management/modal/invite_customer';
import { Search } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Box, Button, InputAdornment, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const CustomerManagementPage = () => {
  const [sendInvite, setSendInvite] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const [view, setView] = useState<'table' | 'card'>('table');
  const [sortBy, setSortBy] = useState<boolean>(false);
  const [searchedValue, setSearchedValue] = useState<string>('');
  const toggleView = () => {
    setView(view === 'table' ? 'card' : 'table');
  };
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const fetchAllCustomers = async () => {
      try {
        await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
      } catch (e) {
        // Catch errors
      }
    };
    fetchAllCustomers();
  }, [id]);


  return (
    <CardWrapper minHeight="80vh" overflow="auto">
      {/* Toggle Button */}
      <Typography variant="h5" color="textSecondary" gutterBottom>Team Management</Typography>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" justifyContent="start" alignItems="center" gap={2} mb={2}>
          <Box>
            <CustomInput
              placeholder="Search..."
              value={searchedValue}
              slotProps={{
                input: {
                    startAdornment: <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                }
            }}
              onChange={(e) => setSearchedValue(e.target.value)}
            />
          </Box>
          <Button variant="outlined" color={sortBy ? 'primary' : 'secondary'} onClick={() => setSortBy(!sortBy)}>
            Sort by
          </Button>
          <Button variant="outlined" color="secondary" onClick={toggleView}>
            Switch to {view === 'table' ? 'Card View' : 'Table View'}
          </Button>
        </Box>
        <Button variant="contained" onClick={() => setSendInvite(true)}>Invite Team</Button>
      </Box>

      {/* Conditional Rendering */}
      <CustomerManagementComponent view={view} search={searchedValue} sort={sortBy} />
      {sendInvite && <InviteCustomerModal open={sendInvite} onClose={() => setSendInvite(false)} />}
    </CardWrapper>
  );
};

export default CustomerManagementPage;